import { HIDE_CAMPAIGNS_LIST_LOADER, SET_CAMPAIGNS_LIST, SHOW_CAMPAIGNS_LIST_LOADER } from "./actionTypes";

const INIT_STATE = {
  data: {
    count: 0,
    next: null,
    previous: null,
    page: 1,
    sizePerPage: 10,
    results: [],
  },
  loading: false,
  loading_vk: false,
  // success: null,
  error: null,
};

const CampaignsList = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_CAMPAIGNS_LIST:
      return {
        ...state,
        data: action.payload,
      };
    case SHOW_CAMPAIGNS_LIST_LOADER:
      return {
        ...state,
        loading: true,
      };
    case HIDE_CAMPAIGNS_LIST_LOADER:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};

export default CampaignsList;
